import ENCardFront from "../../../../../../assets/extra-pay-cards/fidelity_card_en_frente.jpg";
import ENCardBack from "../../../../../../assets/extra-pay-cards/fidelity_card_en_verso.jpg";
import ESCardFront from "../../../../../../assets/extra-pay-cards/fidelity_card_es_frente.jpg";
import ESCardBack from "../../../../../../assets/extra-pay-cards/fidelity_card_es_verso.jpg";
import ITCardFront from "../../../../../../assets/extra-pay-cards/fidelity_card_it_frente.jpg";
import ITCardBack from "../../../../../../assets/extra-pay-cards/fidelity_card_it_verso.jpg";
import PTCardFront from "../../../../../../assets/extra-pay-cards/fidelity_card_pt_frente.jpg";
import PTCardBack from "../../../../../../assets/extra-pay-cards/fidelity_card_pt_verso.jpg";
import Loading from "../../../../../../components/Loading/Loading";
import { useToastContext } from "../../../../../../contexts/ToastContext/ToastContext";
import { useToggle } from "../../../../../../hooks/useToggle";
import localeText from "../../../../../../locale";
import { locale } from "../../../../../../utilities/locale/locale";
import useUserCard from "../../hooks/useUserCard";
import "./styles.css";

const cardImages = {
  pt: {
    front: PTCardFront,
    back: PTCardBack,
  },
  es: {
    front: ESCardFront,
    back: ESCardBack,
  },
  it: {
    front: ITCardFront,
    back: ITCardBack,
  },
  en: {
    front: ENCardFront,
    back: ENCardBack,
  },
};

const formatNumber = (number) => {
  return number.toString().padStart(6, "0");
};

const ExtrapayCard = () => {
  const { showErrorToast } = useToastContext();
  const { cardInfo, isLoading } = useUserCard({ onError: (code) => showErrorToast({ code }) });
  const { value: isFrontCard, toggle: rotateCard } = useToggle(false);

  if (isLoading) return <Loading classNameIcon="text-4xl" />;

  return (
    <div className="flex flex-column">
      <div className="extra-pay-card" onClick={rotateCard}>
        <div className={`extra-pay-card-inner ${isFrontCard ? "rotate" : ""}`}>
          <div className="front">
            <img
              src={cardImages[locale].front}
              className="extra-pay-card-img"
              alt="extrapay front card"
            />
            <p className="extra-pay-card-info-name text-white absolute md:text-base text-xs">
              {cardInfo.user.firstname} {cardInfo.user.surname}
            </p>
            <p className="extra-pay-card-info-purchase text-white absolute md:text-base text-xs">
              {formatNumber(cardInfo.amountOrders)}
            </p>
            <p className="extra-pay-card-info-points text-white absolute md:text-base text-xs">
              {formatNumber(cardInfo.points)}
            </p>
            <p className="extra-pay-card-info-conversionRate text-white absolute md:text-base text-xs">
              {cardInfo.currency} {formatNumber(cardInfo.conversionRate)}
            </p>
          </div>
          <div className="back">
            <img
              src={cardImages[locale].back}
              className="extra-pay-card-img"
              alt="extrapay back card"
            />
          </div>
        </div>
      </div>
      <p className="extrapay-text md:text-base text-xs">{localeText("extrapayRegulation")}</p>
    </div>
  );
};

export default ExtrapayCard;
